import script from "./UserAbnormal.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserAbnormal.vue?vue&type=script&setup=true&lang=ts"

import "./UserAbnormal.vue?vue&type=style&index=0&id=30099eca&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30099eca"]])

export default __exports__